import React, { useState, useEffect } from 'react';
import { message as Message, Button } from 'antd';
import { bindActionCreators, Dispatch } from '@tkit/actions';
import { connect } from 'react-redux';
import { IRootState } from '@src/types';
import { IconFont } from '@src/features/common';
import * as models from '@services/model/models';
// import defaultPhoto from '@src/assets/default-photo.svg';
import actions from '../redux/actions';
import './CommonInfoEdit.less';

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
};

const mapStateToProps = (state: IRootState) => ({});
interface ISProps {
  show: boolean;
  type: string;
  data: any;
  changeShowState: (type: boolean) => void;
}
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = StateProps & DispatchProps & ISProps;

const dataMap = {
  group: {
    title: '圈子',
    titlePlaceholder: '请输入圈子名称',
    descPlaceholder: '写一句圈子描述'
  },
  team: {
    title: '团队',
    titlePlaceholder: '请输入团队名称',
    descPlaceholder: '写一句团队描述'
  }
};

const PersonInfo = (props: Props) => {
  const { type, data, changeShowState, show } = props;

  const [title, setTitle] = useState('');
  const [desc, setDesc] = useState('');
  // 保存
  const save = () => {
    if (type === 'group') {
      const { id: groupId, authentication } = data;
      props.actions.groupUpdate({
        params: { groupId, authentication, groupName: title, profile: desc },
        callBack: (res: models.CommonResult) => {
          const { code, message } = res;
          if (code === 0) {
            changeShowState(false);
          } else {
            Message.error(message);
          }
        }
      });
    } else if (type === 'team') {
      const { id: teamId } = data;
      props.actions.teamUpdate({
        params: { teamId, teamName: title, profile: desc },
        callBack: (res: models.CommonResult) => {
          const { code, message } = res;
          if (code === 0) {
            changeShowState(false);
          } else {
            Message.error(message);
          }
        }
      });
    }
  };
  // close
  const close = () => {
    changeShowState(false);
  };

  useEffect(() => {
    if (type === 'group') {
      const { groupName, profile } = props.data;
      setTitle(groupName);
      setDesc(profile);
    }
    if (type === 'team') {
      const { teamName, profile } = props.data;
      setTitle(teamName);
      setDesc(profile);
    }
  }, [props, type]);

  // 名称改变
  const nameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(e.target.value);
  };
  // 简介改变
  const descChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDesc(e.target.value);
  };
  const { groupName, name, teamName, profile } = data;
  return (
    <div>
      {show && (
        <div className="k-common-info-edit">
          <div className="mask" />
          <div className="main">
            <p className="title">
              编辑{dataMap[type].title}简介
              <IconFont type="icon-close" className="icon-close" onClick={close} />
            </p>
            <div className="info">
              <p className="name">{name}</p>
            </div>
            <div className="desc">
              {dataMap[type].title}名称
              <input
                type="text"
                placeholder={dataMap[type].titlePlaceholder}
                defaultValue={groupName || teamName || name}
                onChange={nameChange}
              />
            </div>
            <div className="desc">
              {dataMap[type].title}简介
              <input
                type="text"
                placeholder={dataMap[type].descPlaceholder}
                defaultValue={profile}
                onChange={descChange}
              />
            </div>
            <div className="bottom">
              <Button type="primary" className="btn" onClick={save}>
                保存修改
              </Button>
              <Button className="btn" onClick={close}>
                取消
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default connect<StateProps, DispatchProps>(mapStateToProps, mapDispatchToProps)(PersonInfo);
